import { normalizeCardInfo } from "./cardInfo";
import { getFundingReadContract } from "./instances";

/** ABI: getAllCards */
export async function fetchAllCardsFromChain() {
  const contract = getFundingReadContract();
  const cardsRaw = await contract.methods.getAllCards().call();
  const cards = cardsRaw || [];
  return cards.map((row, index) => ({
    index,
    info: normalizeCardInfo(row),
  }));
}

export async function fetchAllCardsCount(web3) {
  const contract = getFundingReadContract(web3);
  const cards = await contract.methods.getAllCards().call();
  return (cards || []).length;
}

/** ABI: cardInfo(address) — 详情/认购前按 NFT 代理地址刷新时使用 */
export async function fetchCardInfo(cardAddress) {
  const contract = getFundingReadContract();
  const raw = await contract.methods.cardInfo(cardAddress).call();
  return normalizeCardInfo(raw);
}

/** ABI: calculateTotalPrice */
export async function calculateTotalPriceWei(cardAddress, quantity) {
  const contract = getFundingReadContract();
  return contract.methods.calculateTotalPrice(cardAddress, String(quantity)).call();
}

/** ABI: getOrderList */
export async function fetchUserOrders(userAddress) {
  if (!userAddress) return [];
  const contract = getFundingReadContract();
  return contract.methods.getOrderList(userAddress).call();
}

/** ABI: getDirectShare */
export async function fetchDirectShare(userAddress) {
  if (!userAddress) return [];
  const contract = getFundingReadContract();
  return contract.methods.getDirectShare(userAddress).call();
}

/** ABI: friendship(address) — 已绑定的直接上级 */
export async function fetchFriendship(userAddress) {
  if (!userAddress) return "";
  const contract = getFundingReadContract();
  return contract.methods.friendship(userAddress).call();
}

/** ABI: getUserSubAndRewardData — 按代币汇总的认购与推广奖励 */
export async function fetchUserSubAndRewardData(userAddress) {
  if (!userAddress) {
    return { subscriptions: [], rewards: [] };
  }
  const contract = getFundingReadContract();
  return contract.methods.getUserSubAndRewardData(userAddress).call();
}
